import { ShopperHomePage } from "./../shopper-home/shopper-home";
import { MerchantHomePage } from "./../merchant-home/merchant-home";
import { TranslateService } from "@ngx-translate/core";
import { HomePage } from "./../home/home";
import { Storage } from "@ionic/storage";
import { Http, RequestOptions, Headers } from "@angular/http";
import { ServiceProvider } from "./../../providers/service/service";
import { Component } from "@angular/core";
import { IonicPage, NavController } from "ionic-angular";

@IonicPage()
@Component({
  selector: "page-wait-step3",
  templateUrl: "wait-step3.html",
})
export class WaitStep3Page {
  interval: any;
  theme = 1;

  constructor(
    public navCrl: NavController,
    private services: ServiceProvider,
    private http: Http,
    private storage: Storage,
    private translateService: TranslateService
  ) {}

  async ionViewDidLoad() {
    this.theme = await this.storage.get("theme");

    // console.log('ionViewDidLoad WaitStep2Page');

    var link = this.services.URLCheckStep;

    this.interval = setInterval(() => {
      this.storage.get("token").then((token) => {
        this.storage.get("info").then((info) => {
          var headers = new Headers();
          headers.append("Accept", "application/json");
          headers.append("Authorization", "Bearer " + token);
          const requestOptions = new RequestOptions({ headers: headers });

          this.http
            .get(link, requestOptions)
            .map((res) => res.json())
            .subscribe(
              (data) => {
                if (data.step >= 3) {
                  clearInterval(this.interval);
                  this.storage.set("stepGame", "home");

                  if (info.role == 1) {
                    this.navCrl.setRoot(HomePage);
                  } else if (info.role == 2) {
                    this.navCrl.setRoot(MerchantHomePage);
                  } else if (info.role == 3) {
                    this.navCrl.setRoot(ShopperHomePage);
                  }
                }
              },
              (error) => {
                var response = JSON.parse(error._body);

                this.translateService
                  .get(response.message)
                  .subscribe((value) => {
                    this.services.presentToast(value);
                  });
              }
            );
        });
      });
    }, 10000);
  }

  doRefresh(refresher) {
    this.storage.get("token").then((token) => {
      this.storage.get("info").then((info) => {
        var link = this.services.URLCheckStep;
        var headers = new Headers();
        headers.append("Accept", "application/json");
        headers.append("Authorization", "Bearer " + token);
        const requestOptions = new RequestOptions({ headers: headers });

        this.http
          .get(link, requestOptions)
          .map((res) => res.json())
          .subscribe(
            (data) => {
              if (data.step == 3) {
                clearInterval(this.interval);
                this.storage.set("stepGame", "home");

                if (info.role == 1) {
                  this.navCrl.setRoot(HomePage);
                } else if (info.role == 2) {
                  this.navCrl.setRoot(MerchantHomePage);
                } else if (info.role == 3) {
                  this.navCrl.setRoot(ShopperHomePage);
                }
              }
            },
            (error) => {
              var response = JSON.parse(error._body);

              this.translateService.get(response.message).subscribe((value) => {
                this.services.presentToast(value);
              });
            }
          );
      });
    });

    refresher.complete();
  }
}



// WEBPACK FOOTER //
// ./src/pages/wait-step3/wait-step3.ts